export var criticalVariants = ['cancel', 'decline', 'alert'];
//# sourceMappingURL=StatusModal.types.js.map